var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isShowModal
        ? _c(
            "div",
            {
              directives: [{ name: "drag", rawName: "v-drag" }],
              staticClass:
                "modal-container pointer truelandUiModalContainer draggable",
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "record-container",
                },
                [
                  _c("div", { staticClass: "record-top" }, [
                    _c("div", {
                      staticClass: "record-circle",
                      style: {
                        background:
                          _vm.recorderState === "recording"
                            ? "#fff"
                            : "transparent",
                      },
                    }),
                    _c("div", { staticClass: "top-scroll-part" }, [
                      _c(
                        "div",
                        { staticClass: "marquee-box" },
                        [
                          _c(
                            "marquee",
                            {
                              staticClass: "record-file-name",
                              attrs: {
                                width: "210",
                                direction: "left",
                                align: "middle",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.audioData["title"]) + " ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm.recorderIsEnd && _vm.multipartUploadParams.Bucket != ""
                      ? _c(
                          "div",
                          {
                            staticClass: "downloadBtn",
                            on: { click: _vm.localDownload },
                          },
                          [_c("i", { staticClass: "el-icon-upload" })]
                        )
                      : _vm._e(),
                    _c("img", {
                      staticClass: "record-close",
                      attrs: { src: _vm.recordClose, alt: "" },
                      on: { click: _vm.closeRecordModal },
                    }),
                  ]),
                  _c("div", { staticClass: "record-bottom" }, [
                    _vm.recorderState === "recording"
                      ? _c("img", {
                          staticClass: "audio-background",
                          attrs: { src: _vm.audioPlayBackground },
                        })
                      : _c("img", {
                          staticClass: "audio-background",
                          attrs: { src: _vm.audioPauseBackground },
                        }),
                    _vm.recorderState === "inactive" ||
                    _vm.recorderState === "paused"
                      ? _c(
                          "div",
                          {
                            staticClass: "common-circle left-circle",
                            on: { click: _vm.playHandler },
                          },
                          [_c("img", { attrs: { src: _vm.playPic, alt: "" } })]
                        )
                      : _vm._e(),
                    _vm.recorderState === "recording"
                      ? _c(
                          "div",
                          {
                            staticClass: "common-circle left-circle",
                            on: { click: _vm.pauseHandler },
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.recordPausePic, alt: "" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "common-circle right-circle",
                        on: { click: _vm.stopHandler },
                      },
                      [_c("img", { attrs: { src: _vm.redCirclePic, alt: "" } })]
                    ),
                    _c("div", { staticClass: "record-status-text-box" }, [
                      _c("span", { staticClass: "record-status-text" }, [
                        _vm._v(_vm._s(_vm.recordStatusText)),
                      ]),
                    ]),
                    _c("div", { staticClass: "record-time-box" }, [
                      _c("span", { staticClass: "record-time" }, [
                        _vm._v(_vm._s(_vm.time)),
                      ]),
                    ]),
                    typeof _vm.audioData.uploadPercent === "number"
                      ? _c("div", { staticClass: "record-progress-box" }, [
                          _c("div", {
                            staticClass: "record-progress-current",
                            style: _vm.progressStyle,
                          }),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("microphone-permission-guide", {
        on: { close: _vm.handlePermissionGuideClose },
        model: {
          value: _vm.showPermissionGuide,
          callback: function ($$v) {
            _vm.showPermissionGuide = $$v
          },
          expression: "showPermissionGuide",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }